import { axiosi } from "../../config/axios";
import { collection, query, where, getDocs, doc, updateDoc, deleteDoc, addDoc } from "firebase/firestore";
import { db } from "../../firebase";

// export const addAddress=async(address)=>{
//     try {
//         const res=await axiosi.post("/address",address)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const addAddress = async (address) => {
    try {
        console.log('dd',address)
        const ref = await addDoc(collection(db, "addresses"), address);

        return {
            success: true,
            message: "Address added successfully!",
            _id: ref.id,
            ...address,
        };

    } catch (error) {
        console.error(error);
        throw {
            success: false,
            message: "Failed to add address",
            error,
        };
    }
};


// export const fetchAddressByUserId=async(id)=>{
//     try {
//         const res=await axiosi.get(`/address/users/${id}`)
//         // return res.data
//     } catch (error) {
//         // throw error.response.data
//         return [
//             {
//                 "_id": "65c26398e1e1a2106ac8fbd5",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "street": "main 11th",
//                 "city": "Indrapuram",
//                 "state": "Uttar Pradesh",
//                 "phoneNumber": "9452571272",
//                 "postalCode": "201012",
//                 "country": "India",
//                 "type": "Home",
//                 "__v": 0
//             },
//             {
//                 "_id": "65c26412e1e1a2106ac8fbd8",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "street": "main 18th",
//                 "city": "Noida",
//                 "state": "Uttar Pradesh",
//                 "phoneNumber": "9846286159",
//                 "postalCode": "301273",
//                 "country": "India",
//                 "type": "Buisness",
//                 "__v": 0
//             }
//         ]
//     }
// }

export const fetchAddressByUserId = async (id) => {
    try {
        const q = query(
            collection(db, "addresses"),
            where("user", "==", id)
        );

        const snap = await getDocs(q);

        return snap.docs.map((doc) => ({
            _id: doc.id,
            ...doc.data(),
        }));

    } catch (error) {
        console.error(error);

        // Dummy fallback
        return [
            {
                _id: "65c26398e1e1a2106ac8fbd5",
                user: id,
                street: "main 11th",
                city: "Indrapuram",
                state: "Uttar Pradesh",
                phoneNumber: "9452571272",
                postalCode: "201012",
                country: "India",
                type: "Home",
            },
            {
                _id: "65c26412e1e1a2106ac8fbd8",
                user: id,
                street: "main 18th",
                city: "Noida",
                state: "Uttar Pradesh",
                phoneNumber: "9846286159",
                postalCode: "301273",
                country: "India",
                type: "Business",
            },
        ];
    }
};


// export const updateAddressById=async(update)=>{
//     try {
//         const res=await axiosi.patch(`/address/${update._id}`,update)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const updateAddressById = async (update) => {
    try {
        const ref = doc(db, "addresses", update._id);

        // Firestore me updateDoc automatically sirf changed fields update karta hai
        await updateDoc(ref, {
            ...update
        });

        return {
            success: true,
            message: "Address updated successfully!",
            data: update,
        };

    } catch (error) {
        console.error(error);
        throw {
            success: false,
            message: "Failed to update address",
            error,
        };
    }
};

// export const deleteAddressById=async(id)=>{
//     try {
//         const res=await axiosi.delete(`/address/${id}`)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const deleteAddressById = async (id) => {
    try {
        const ref = doc(db, "addresses", id);

        await deleteDoc(ref);

        return {
            success: true,
            message: "Address deleted successfully!",
            id,
        };

    } catch (error) {
        console.error(error);
        throw {
            success: false,
            message: "Failed to delete address",
            error,
        };
    }
};